"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sleep = exports.timeoutAsync = void 0;
/**
 * @description Função timeout para aguardar um tempo determinado porém, é assíncrona
 * @param ms Número de milissegundos a esperar
 * @returns Uma promise que resolve após o tempo especificado
 */
function timeoutAsync(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
exports.timeoutAsync = timeoutAsync;
/**
 * @description Função parecida com timeout que executa outra função, porém, retorna uma promise
 * @param ms Número de milissegundos a esperar
 * @param fn Uma função(assíncrona ou não) a ser executada após o tempo especificado
 * @param args Um array com os argumentos sequências da função a ser executada
 * @returns O resultado da função a ser executada
 */
async function sleep(ms, fn, args) {
  await timeoutAsync(ms);
  const valueToReturn = await fn(...args);
  return valueToReturn;
}
exports.sleep = sleep;